
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organizationSlug]/settings/[settingsTab]",
      function () {
        return require("private-next-pages/[organizationSlug]/settings/[settingsTab].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organizationSlug]/settings/[settingsTab]"])
      });
    }
  